// extracted by mini-css-extract-plugin
export default {"breadcrumb":"BreadCrumb_breadcrumb__k9ZVH","breadcrumb__item":"BreadCrumb_breadcrumb__item__GX+f5"};